import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LegalDocument from '../../components/Legal/LegalDocument';
import { PRIVACY_META, PRIVACY_SECTIONS } from '../../content/privacyContent';
import '../../components/Legal/LegalDocument.css';

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-page__header">
        <button type="button" className="legal-page__back" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} strokeWidth={2.5} />
          Retour
        </button>
      </header>
      <div className="legal-page__content">
        <LegalDocument meta={PRIVACY_META} sections={PRIVACY_SECTIONS} />
      </div>
    </div>
  );
}
